import CategoryPage from './category'

export default CategoryPage
